import { EmptyExamineeFamily, NewExamineeFamily } from '../../interfaces/ExamineeFamily';
import { ErrorLevel, useAddError, useClearError } from '../../context/error';
import { Formik, FormikHelpers } from 'formik';
import { FunctionComponent, useState } from 'react';

import BareInput from '../../components/form/BareInput';
import { ExamineeFamiliesService } from '../../services';
import InputGroup from '../../components/form/InputGroup';
import InputSection from '../../components/form/InputSection';
import { Row } from 'react-bootstrap';
import Title from '../../components/title';
import { get } from 'lodash';
import { useNavigate } from 'react-router-dom';
import validateName from '../../helpers/validate/validateName';

const New: FunctionComponent = () => {
  const addError = useAddError();
  const clearError = useClearError();

  const navigate = useNavigate();

  const [item] = useState<NewExamineeFamily>(EmptyExamineeFamily);

  const onSubmit = async (values: NewExamineeFamily, { setSubmitting }: FormikHelpers<NewExamineeFamily>) => {
    setSubmitting(true);
    clearError();
    try {
      const id = await ExamineeFamiliesService(addError).create(values);
      if (id && id > 0) {
        navigate(`/settings/examinee-families/${id}`);
      }
    } catch (error) {
      addError({
        level: ErrorLevel.danger,
        message: get(error, 'message', 'Unbekannter Fehler'),
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik enableReinitialize={true} initialValues={item} onSubmit={onSubmit}>
      {({ handleSubmit, isValidating, isValid, errors, isSubmitting, touched }) => (
        <form autoComplete="off" onSubmit={handleSubmit}>
          <Title
            onCancel={() => {
              navigate('..');
            }}
            editing={true}
            editingValid={!isValidating && isValid && Object.keys(touched).length > 0}
            isSubmitting={isSubmitting}
            title={'Neue Prüflingsgattung'}
          />
          <Row>
            <InputSection title="Stammdaten" xs={12} xl={6}>
              <InputGroup error={errors.name} valid={!errors.name} title="Name" name="name">
                <BareInput disabled={isSubmitting} type="text" name="name" validate={validateName} />
              </InputGroup>
            </InputSection>
          </Row>
        </form>
      )}
    </Formik>
  );
};

export default New;
